module.exports = __webpack_public_path__ + "img/HelpLsb2.c5976a3f.png";